import type { ReactNode } from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

export interface AITableCardProps {
  title?: string;
  children: ReactNode;
  actions?: ReactNode;
}

export function AITableCard({ title, children, actions }: AITableCardProps) {
  return (
    <div className="ai-viz-zone" aria-label={title || 'Data table'}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        {title ? <Text strong>{title}</Text> : <span />}
        {actions}
      </div>
      {children}
    </div>
  );
}
